import { useContext, useEffect, useRef, useState } from "react";
import {
  Avatar,
  CheckIcon,
  FabButton,
  FabContainer,
  FamilyItem,
  Popover,
} from "./localStyle";
import MiGrupoFamiliarIcon from "_+_Portal/assets/images/generico/MiGrupoFamiliarIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import camelize from "global/utils/camelize";
import { GlobalContext } from "global/context/Provider";

const FloatingSelect = ({ familiares, selectItem }) => {
  const { authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const popoverRef = useRef(null);

  // Función para detectar clics fuera del popover
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <FabContainer>
      {familiares && (
        <>
          <FabButton ref={buttonRef} onClick={() => setIsOpen(!isOpen)}>
            <MiGrupoFamiliarIcon color={"var(--color-white)"} size={28} />
          </FabButton>
          {isOpen && (
            <Popover ref={popoverRef} $isOpen={isOpen}>
              {familiares.map((familiar, index) => {
                return (
                  <FamilyItem
                    key={index}
                    onClick={() => {
                      setIsOpen(false);
                      selectItem(familiar);
                    }}
                  >
                    <Avatar
                      selected={
                        selectDropDownState.selectDropDown.selectGlobal
                          .pacienteElegido !== false
                          ? selectDropDownState.selectDropDown.selectGlobal
                              .pacienteElegido.id === familiar.id
                          : authState.auth.data.paciente.codigo === familiar.id
                      }
                    >
                      <CheckIcon>✔</CheckIcon>
                    </Avatar>
                    {camelize(familiar.nombre)}
                  </FamilyItem>
                );
              })}
            </Popover>
          )}
        </>
      )}
    </FabContainer>
  );
};

export default FloatingSelect;
